import { Controller } from "@hotwired/stimulus"

// Opens a native <dialog> element by ID.
// Usage: data-controller="dialog-opener" data-dialog-opener-dialog-id-value="my-dialog"
//        data-action="click->dialog-opener#open"
//
// Dispatches `dialog:open` on the dialog itself, so a dialog with content to build
// can do it when it is actually shown rather than on every page load.
export default class extends Controller {
  static values = { dialogId: String }

  open() {
    const dialog = document.getElementById(this.dialogIdValue)
    if (dialog) {
      dialog.showModal()
      document.body.style.overflow = "hidden"
      dialog.dispatchEvent(new CustomEvent("dialog:open"))
    }
  }
}
